import { createStoreGetters } from "@mirage-web/utils/root-store";
import { createUseStoreWithSelectorDeferred } from "@mirage-web/utils/zustand-store";
import { createStore } from "zustand";
import { combine } from "zustand/middleware";

export function createConfigStore() {
  const appEnv = import.meta.env.VITE_APP_ENV as "dev" | "test" | "preview" | "prod";
  const defaultCapCodeApiUrl =
    appEnv === "dev" || appEnv === "test"
      ? "http://localhost:8787"
      : "https://cap-code.nocapinc.workers.dev";
  const baseEnv = {
    APP_ENV: appEnv,
    CAP_SRV_API_URL: import.meta.env.VITE_CAP_SRV_API_URL,
    CAP_CODE_API_URL: import.meta.env.VITE_CAP_CODE_API_URL ?? defaultCapCodeApiUrl,
    CAMEL_API_URL: import.meta.env.VITE_CAMEL_API_URL,

    // injected by Cloudflare Pages + build commands
    COMMIT_SHA: import.meta.env.VITE_CF_PAGES_COMMIT_SHA ?? "unknown",
    BRANCH: import.meta.env.VITE_CF_PAGES_BRANCH ?? "unknown",
  };

  return createStore(
    combine(
      {
        env: { ...baseEnv },
        originalEnv: { ...baseEnv },
      },
      (set, _get) => {
        return {
          async init() {},
          setConfigVar(key: keyof typeof baseEnv, value: string) {
            set((state) => ({
              env: {
                ...state.env,
                [key]: value,
              },
            }));
          },
          resetConfigVar(key: keyof typeof baseEnv) {
            set((state) => ({
              env: {
                ...state.env,
                [key]: state.originalEnv[key],
              },
            }));
          },
          resetAllConfigVars() {
            set((state) => ({
              env: { ...state.originalEnv },
            }));
          },
        };
      }
    )
  );
}

type ConfigStore = ReturnType<ReturnType<typeof createConfigStore>["getState"]>;

export type ConfigEnvVarKey = keyof ConfigStore["env"];

export const {
  getStore: getConfigStore,
  getStoreAsync: getConfigStoreAsync,
  getStoreApi: getConfigStoreApi,
} = createStoreGetters<ConfigStore>("config");

export const useConfigStore = createUseStoreWithSelectorDeferred(() => getConfigStoreApi());
